import { AgeVerification } from "@next-platform/packages-ts-types";

export enum ProfileFormFields {
  USERNAME = "username",
  NAME = "name",
  AVATAR = "avatar_url",
  HIGHLIGHTS = "highlights",
}

export interface IUpdateProfilePayload {
  username: string;
  name: string;
  avatar_url?: string;
  highlights?: string;
  openai_api_key?: string;
  openai_mode?: string;
  age_verification?: AgeVerification;
}
